var map = {
	"./flags/en.svg": 813,
	"./flags/es.svg": 814,
	"./flags/fr.svg": 815,
	"./flags/it.svg": 816,
	"./flags/nl.svg": 817,
	"./flags/pt.svg": 818,
	"./icons/icon-arrow-down.svg": 137,
	"./icons/icon-arrow-up.svg": 138,
	"./icons/icon-beach--green.svg": 819,
	"./icons/icon-beach--red.svg": 820,
	"./icons/icon-beach.svg": 821,
	"./icons/icon-break.svg": 822,
	"./icons/icon-chevron-circle-left.svg": 823,
	"./icons/icon-chevron-circle-right.svg": 824,
	"./icons/icon-info--circle.svg": 825,
	"./icons/icon-legend-buoys.svg": 826,
	"./icons/icon-legend-star.svg": 827,
	"./icons/icon-legend-swell-arrow.svg": 828,
	"./icons/icon-legend-swell.svg": 829,
	"./icons/icon-legend-wind.svg": 830,
	"./icons/icon-point--green.svg": 831,
	"./icons/icon-point--red.svg": 832,
	"./icons/icon-point.svg": 833,
	"./icons/icon-reef--green.svg": 834,
	"./icons/icon-reef--red.svg": 835,
	"./icons/icon-reef.svg": 836,
	"./icons/icon-river--green.svg": 837,
	"./icons/icon-river--red.svg": 838,
	"./icons/icon-river.svg": 839,
	"./icons/icon-sandbar--green.svg": 840,
	"./icons/icon-sandbar--red.svg": 841,
	"./icons/icon-sandbar.svg": 842,
	"./icons/icon-tidal-range--blue.svg": 843,
	"./icons/icon-tide-clock--color.svg": 844,
	"./icons/icon-tide-needle.svg": 845,
	"./icons/icon-tide-star.svg": 846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 812;